<div class="auth-container">
	<lib-toastify-toast-container
		position="bottom-right"
	></lib-toastify-toast-container>

	<div class="auth-content">
		<router-outlet></router-outlet>
	</div>
</div>